import { KENTICO_TYPES } from 'common/consts/kentico';

const arrangeKenticoStructure = (content) => {
  if (!content) {
    return [];
  }

  const { structure } = content;
  if (!structure) {
    return [];
  }
  return structure.reduce((accumulator, currentValue) => {
    if (currentValue.system.type === KENTICO_TYPES.NAVIGATOR) {
      accumulator[accumulator.length] = {
        sectionName: currentValue.menu_link_name.text,
        urlSlug: (currentValue.product_slugs && currentValue.product_slugs.value
          && currentValue.product_slugs.value.length > 0)
          ? currentValue.product_slugs.value[0].name
          : null,
        models: [],
      };
    } else if (accumulator[accumulator.length - 1] && accumulator[accumulator.length - 1].models) {
      accumulator[accumulator.length - 1].models.push(currentValue);
    }
    return accumulator;
  }, []);
};

export default arrangeKenticoStructure;



// WEBPACK FOOTER //
// ./src/services/KenticoStructureParser.js